import styled from "styled-components";

export const SelectorContainer = styled.div`
    max-width: 520px;
    padding: 48px 32px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
`;

export const SelectorTitle = styled.h2`
    font-family: Anton;
    font-weight: 400;
    font-style: Regular;
    font-size: 36px;
    leading-trim: NONE;
    line-height: 38px;
    letter-spacing: 0%;
    text-transform: uppercase;
    margin-bottom: 10px;
    margin-top: 0;
`;

export const SelectorSubtitle = styled.p`
    font-family: Overpass;
    font-weight: 300;
    font-style: Light;
    font-size: 20px;
    leading-trim: NONE;
    line-height: 28px;
    letter-spacing: 0%;
    margin: 10px 0 15px 0;
`;

export const OptionsContainer = styled.div`
    max-width: 430px;
    margin-bottom: 20px;
`;

export const Option = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
    border-bottom: 1px solid #bfc0c7;
    padding: 12px 0;

    &:first-child {
        background-color: #red;
        border-top: 1px solid #bfc0c7;
    }
`;

export const OptionImage = styled.img`
    width: 55px;
    height: 88px;
    margin: 0 10px;
`;

export const OptionCheckbox = styled.input`
    width: 20px;
    height: 20px;
    flex-shrink: 0;
`;

export const OptionDetails = styled.p`
    margin: 0;
    user-select: none;
    margin-right: 16px;
`;

export const OptionTitle = styled.h5`
    font-family: Overpass;
    font-weight: 700;
    font-style: Bold;
    font-size: 16px;
    leading-trim: NONE;
    line-height: 24px;
    letter-spacing: 0%;
    vertical-align: middle;
    text-transform: uppercase;
    margin: 0;
`;

export const OptionSubtitle = styled.p`
    font-family: Overpass;
    font-weight: 400;
    font-style: Regular;
    font-size: 16px;
    leading-trim: NONE;
    line-height: 24px;
    letter-spacing: 0%;
    margin: 0;
`;

export const RegisterButton = styled.a`
    height: 48px;
    border-radius: 24px;
    border-width: 1px;
    opacity: 1;
    padding-top: 10px;
    padding-right: 22px;
    padding-bottom: 10px;
    padding-left: 22px;
    gap: 2px;
    align-self: stretch;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 12px 6px;
    text-decoration: none;
    letter-spacing: normal;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #FFF;
    border: 1px solid ${props => props.theme.palette.primary.border};
    border-radius: 24px;
    background: ${props => props.theme.palette.primary.normal};
    cursor: pointer;

    &:hover {
        background: ${props => props.theme.palette.primary.hover};
    }
`;

export const LoginButton = styled.a`
    font-family: Overpass;
    font-weight: 700;
    font-style: Bold;
    font-size: 16px;
    leading-trim: NONE;
    line-height: 24px;
    letter-spacing: 0%;
    text-align: center;
    text-decoration: underline;
    text-decoration-style: solid;
    text-decoration-offset: 0%;
    text-decoration-thickness: 0%;
    color: #000;
    align-self: stretch;
`;